<template>
  <div class="audit-page">
    <div class="callback-box">
      <div
        @click="$router.push({ name: currentAuditName })"
        style="margin-left: 24px; text-align: right; margin-bottom: 6px"
      >
        <img
          style="width: 30px; height: 30px; cursor: pointer"
          src="~@/assets/images/img59.png"
          alt=""
          title="返回"
        />
      </div>
    </div>
    <!-- 顶部筛选区域 -->
    <div class="label-box flex flex-between align-items-center">
      <div class="name-box">
        <span class="info-item">
          <label class="label-text">学校</label>
          <span class="info-value">{{ school }}</span>
        </span>
        <span class="info-item">
          <label class="label-text">工作室</label>
          <span class="info-value">{{ studio || school }}</span>
        </span>
      </div>
      <div class="action-box">
        <span class="filter-item">
          <label class="label-text">审核状态</label>
          <a-checkbox-group
            v-model="filters.auditStatus"
            :options="auditStatusOptions"
            @change="getDetail"
          />
        </span>
        <span class="filter-item">
          <label class="label-text">时间范围</label>
          <a-range-picker
            v-model="filters.dateRange"
            @change="getDetail"
            :locale="locale"
          >
            <!-- <template slot="dateRender" slot-scope="current">
              <div class="ant-calendar-date">
                {{ current.date() }}
              </div>
            </template> -->
          </a-range-picker>
        </span>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="content-box flex">
      <!-- 左侧申请列表 -->
      <div class="left">
        <div class="title">
          <div class="flex align-items-center flex-between">
            <span class="title-text">{{ title }}</span>
            <div class="title-right">
              <span class="audit-total">{{ auditTotal }}</span>
            </div>
          </div>
          <div class="flex" style="margin-top: 12px; justify-content: flex-end">
            <template v-if="isEducationRole">
              <div class="action-buttons flex" style="gap: 12px">
                <span
                  class="btn-action btn-pass"
                  @click="handleBatchAudit('pass', 'left')"
                  >批量通过</span
                >
                <span
                  class="btn-action btn-reject"
                  @click="handleBatchAudit('reject', 'left')"
                  >批量驳回</span
                >
              </div>
            </template>
          </div>
        </div>
        <div class="list-box">
          <div v-if="!filterAuditItems.length" class="empty-state">
            <a-empty description="暂无更新数据" />
          </div>
          <div v-else>
            <!-- 左侧批量审核复选框 -->
            <div class="detail-checkbox" v-if="isEducationRole">
              <a-checkbox
                :indeterminate="isBatchIndeterminate"
                :checked="isBatchAllChecked"
                @change="handleBatchCheckAll"
              >
                全选
              </a-checkbox>
            </div>
            <div class="detail-list-box">
              <a-checkbox-group
                @change="onBatchChange"
                v-model="checkedBatchList"
              >
                <div
                  v-for="item in filterAuditItems"
                  :key="item.id"
                  class="item"
                  :class="{ active: activeApplication.id === item.id }"
                  @click="handleItemSelect(item)"
                >
                  <div class="item-checkbox" @click.stop>
                    <a-checkbox :value="item.id" style="margin-right: 8px" />
                  </div>
                  <div class="item-content">
                    <div class="item-title">{{ item.title }}</div>
                    <div class="num-box">
                      <!-- <span>
                新增:<span class="num-text">{{ item.INSERTNum || 0 }}</span
                >条
              </span>
              <span>
                修改:<span class="num-text">{{ item.UPDATENum || 0 }}</span
                >条
              </span> -->
                      <span>
                        待审核:<span class="num-text">{{
                          item.pendingReviewNum || 0
                        }}</span
                        >个
                      </span>
                      <span>
                        已通过:<span class="num-text">{{
                          item.auditPassedNum || 0
                        }}</span
                        >个
                      </span>
                      <span>
                        已驳回:<span class="num-text">{{
                          item.auditRejectedNum || 0
                        }}</span
                        >个
                      </span>
                    </div>
                    <!-- <span>
                  已撤销:<span class="num-text">{{ item.revokedNum || 0 }}</span
                  >个
                </span> -->
                  </div>
                </div>
              </a-checkbox-group>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧详情区域 -->
      <div class="right">
        <div class="right-title flex align-items-center flex-between">
          <span class="title-with-bar flex align-items-center">
            <span class="bar"></span>
            <span>更新详情</span>
          </span>
          <template v-if="isEducationRole">
            <div>
              <span class="action-buttons flex">
                <span
                  class="btn-action btn-pass"
                  @click="handleBatchAudit('pass', 'right')"
                  >批量通过</span
                >
                <span
                  class="btn-action btn-reject"
                  @click="handleBatchAudit('reject', 'right')"
                  >批量驳回</span
                >
              </span>
            </div>
          </template>
        </div>
        <div class="empty-state" v-if="!detailList.length">
          <a-empty description="暂无更新数据" />
        </div>
        <div class="detail-box" v-else>
          <div class="first-title">{{ activeApplication.title }}</div>
          <div class="detail-content-box">
            <div class="second-title">更新内容预览</div>
            <!-- 空状态提示 -->
            <div v-if="!hasDetailData" class="empty-state">
              <a-empty :description="description" />
            </div>
            <template v-else>
              <div class="detail-checkbox" v-if="isEducationRole">
                <a-checkbox
                  :indeterminate="isIndeterminate"
                  :checked="isAllChecked"
                  @change="handleCheckAll"
                >
                  全部
                </a-checkbox>
              </div>

              <div class="detail-list-box">
                <a-checkbox-group @change="onChange" v-model="checkedList">
                  <div
                    v-for="item in detailList"
                    :key="item.id"
                    class="detail-item"
                  >
                    <div>
                      <div class="detail-title-box flex flex-between">
                        <div class="left-content flex align-items-center">
                          <a-checkbox
                            :value="item.id"
                            style="margin-right: 8px"
                            :disabled="item.auditState != 1"
                          ></a-checkbox>
                          <span class="detail-text flex aligin-items-center">
                            <span class="activeApplicationTitle">{{
                              activeApplication.title
                            }}</span>
                            (
                            <span
                              class="operation-type"
                              :class="item.operation"
                              >{{ typeMap[item.operation] }}</span
                            >)
                          </span>
                          <span class="applyNo">更新编号：{{ item.id }}</span>
                          <span class="submit-time"
                            >提交时间：{{
                              formatTime(item.lastSubmitTime)
                            }}</span
                          >
                        </div>
                        <div
                          class="right-content link-button"
                          @click="getTimeLine(item)"
                        >
                          审核记录
                        </div>
                      </div>

                      <div class="detail-content">
                        <div class="audit-status-box flex align-items-center">
                          <span
                            class="evidence-material flex align-items-center"
                            @click="showeVidence(item)"
                          >
                            <img
                              class="icon-audit"
                              src="@/assets/images/audit/add.png"
                              alt="佐证材料图标"
                            />
                            佐证材料
                          </span>
                          <span
                            :class="[
                              'status-tag',
                              statusClassMap[item.auditState],
                            ]"
                          >
                            {{ statusTextMap[item.auditState] }}
                          </span>
                        </div>
                        <!-- 修改 -->
                        <template v-if="item.operation == 'UPDATE'">
                          <Diff
                            :obj1="changeJson(item.dataTransBefore)"
                            :obj2="changeJson(item.datTransAfter)"
                            :fieldLabels="currentFieldLabels"
                            :old-data="oldData"
                            :new-data="newData"
                            style="margin-top: 35px"
                            @preview="handlePreview"
                          />
                        </template>
                        <template v-else-if="item.operation == 'INSERT'">
                          <div class="text-cont">
                            <a-descriptions bordered :column="2">
                              <a-descriptions-item
                                :label="currentFieldLabels[key]"
                                v-if="changeJson(item.datTransAfter)[key]"
                                v-for="(value, key) in currentFieldLabels"
                              >
                                <span
                                  :style="{
                                    cursor: cursorPointer.includes(
                                      currentFieldLabels[key]
                                    )
                                      ? 'pointer'
                                      : 'default',
                                  }"
                                  @click="
                                    handlePreview(
                                      changeJson(item.datTransAfter),
                                      key
                                    )
                                  "
                                >
                                  {{ changeJson(item.datTransAfter)[key] }}
                                </span>
                              </a-descriptions-item>
                            </a-descriptions>
                            <!-- <div
                              v-for="(value, key) in currentFieldLabels"
                              :key="key"
                              class="text-item flex align-items-center"
                            >
                              <span class="text-title"
                                >{{ currentFieldLabels[key] }}:</span
                              >
                              <span class="diff-value">{{
                                changeJson(item.datTransAfter)[key]
                              }}</span>
                            </div> -->
                          </div>
                        </template>
                        <template v-else>
                          <div class="text-cont">
                            <a-descriptions bordered :column="2">
                              <a-descriptions-item
                                :label="currentFieldLabels[key]"
                                v-if="changeJson(item.dataTransBefore)[key]"
                                v-for="(value, key) in currentFieldLabels"
                              >
                                <span
                                  :style="{
                                    cursor: cursorPointer.includes(
                                      currentFieldLabels[key]
                                    )
                                      ? 'pointer'
                                      : 'default',
                                  }"
                                  @click="
                                    handlePreview(
                                      changeJson(item.dataTransBefore),
                                      key
                                    )
                                  "
                                >
                                  {{ changeJson(item.dataTransBefore)[key] }}
                                </span>
                              </a-descriptions-item>
                            </a-descriptions>
                            <!-- <div
                              v-for="(value, key) in currentFieldLabels"
                              :key="key"
                              class="text-item flex align-items-center"
                            >
                              <span class="text-title"
                                >{{ currentFieldLabels[key] }}:</span
                              >
                              <span class="diff-value">{{
                                changeJson(item.datTransAfter)[key]
                              }}</span>
                            </div> -->
                          </div>
                        </template>
                        <div
                          class="action-bar flex align-items-center"
                          v-if="item.auditState != 2"
                        >
                          <span
                            v-if="item.auditState == 3"
                            class="reason flex align-items-center"
                            @click="handleShowReason(item)"
                          >
                            驳回原因
                            <img
                              class="icon-reason icon-audit"
                              src="@/assets/images/audit/reason.png"
                              alt="原因图标"
                            />
                          </span>

                          <span
                            v-if="isEducationRole && item.auditState == 1"
                            class="action-buttons flex"
                          >
                            <span
                              class="btn-action btn-pass"
                              @click="handleItemAudit(item, 'pass')"
                              >审核通过</span
                            >
                            <span
                              class="btn-action btn-reject"
                              @click="handleItemAudit(item, 'reject')"
                              >审核驳回</span
                            >
                          </span>
                          <span
                            v-if="!isEducationRole"
                            class="action-buttons flex"
                          >
                            <span
                              v-if="
                                item.auditState == 3 || item.auditState == 4
                              "
                              class="btn-audit btn-edit"
                              @click="handleEdit(item)"
                              >修改申请</span
                            >
                            <span
                              v-if="item.auditState == 1"
                              class="btn-audit btn-cancel"
                              @click="handleCancel(item)"
                              >撤销申请</span
                            >
                            <!-- <span
                              v-if="item.auditState == 3"
                              type="primary"
                              class="btn-audit btn-commit"
                              @click="handleResubmit(item)"
                              >重新提交</span
                            > -->
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a-checkbox-group>
              </div>
              <a-pagination
                class="page-bar"
                :page-size="params.pageSize"
                :current="params.pageNo"
                @change="handlePageChange"
                :total="total"
              />
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- 审核详情 -->
    <TimeLine ref="timeLine" />

    <!-- 展示驳回原因 -->
    <Reason ref="reason" />

    <!-- 输入驳回原因 -->
    <RejectReason
      ref="rejectReason"
      @handleRejectSuccess="handleRejectSuccess"
    />

    <!-- 审核详情文件查看 -->
    <div class="preview-pop-box" v-if="showiframe">
      <div class="preview-boxs" style="height: 90%">
        <newpreview
          :previewUrl="previewUrl"
          @closePreview="showiframe = false"
          :dialogTitle="dialogTitle"
        ></newpreview>
      </div>
    </div>

    <!-- 佐证材料 -->
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <Evidencelist
          :title="evidencelistTitle"
          :isEdit="isEdit"
          :id="id"
          @closePreview="showtable = false"
          :dataid="sj.id"
        />
      </div>
    </div>
    <!-- 视频预览 -->
    <div class="preview-pop-box" v-if="showvideo">
      <div class="preview-boxs" style="height: 600px">
        <!-- :previewUrl="previewUrl" -->
        <videopreview
          :sj="sjData"
          @closePreview="showvideo = false"
        ></videopreview>
      </div>
    </div>
    <!-- 工作室编辑组件 -->
    <!-- 工作室基本信息 -->
    <gzsBase ref="GZSJIBENXINXI" @init="init" />
    <!-- 编辑工作室老师 -->
    <add-teacher ref="GZSTUANDUI" @addTeacher="init" />
    <!-- 添加教研老师 -->
    <addTeachRearch ref="GZSJIAOYANQINGKUANG" @addGain="init"></addTeachRearch>
    <!-- 编辑编辑资金支出 -->
    <found-pay ref="GZSZIJINZICHU" @foundPay="init" />
    <!-- 科研情况 -->
    <addScientificeRearch
      ref="GZSKEYANQINGKUANG"
      @addGain="init"
    ></addScientificeRearch>
    <!-- 活动方案模块 -->
    <addActivityPlan ref="GZSHUODONGFANGAN" @addGain="init"></addActivityPlan>
    <!-- 编辑活动 -->
    <AddActive ref="GZSKCZSSZKC" @addGain="init" />
    <!-- 标志性成果 -->
    <AddResult ref="GZSBIAOZHIXINGCHENGGUO" @addGain="init"></AddResult>
    <!-- 编辑培育品牌 -->
    <AddBrand ref="PEIYUPINPAI" @addGain="init" />
    <!-- 编辑资金来源 -->
    <found-source ref="GZSZIJINYUSUAN" @foundPay="init" />
    <!-- 编辑荣誉 -->
    <AddHonor ref="GZSRONGYU" @addGain="init" />
    <!-- 编辑团队建设 -->
    <AddTeamBuild ref="GZSTUANDUIJIANSHE" @addGain="init" />
    <!-- 添加思政实践基地 -->
    <AddBase ref="GZSSHIJIANJIDI" @addBase="init"></AddBase>
    <!-- 添加思政实践活动 -->
    <AddBaseActive ref="GZSJIDIHUODONG" @addGain="init"></AddBaseActive>
    <!-- 思政微课-->
    <!-- 品牌编辑组件 -->
    <!-- 品牌基本信息 -->
    <pp-base ref="PPJIBENXINXI" @init="init"></pp-base>
    <!-- 添加老师 -->
    <pp-add-teacher ref="PPTUANDUI" @addTeacher="init"></pp-add-teacher>
    <!-- 品牌资金预算 -->
    <pp-found-source ref="PPZHIJINYUSUAN" @foundPay="init"></pp-found-source>
    <!-- 品牌资金使用 -->
    <pp-found-pay ref="PPZHIJINSHIYONG" @foundPay="init"></pp-found-pay>
    <!-- 年度计划 -->
    <PpAddAnnualPlan
      ref="PPNIANDUJIAHUAN"
      @addAnnualPlan="init"
    ></PpAddAnnualPlan>
    <!-- 品牌活动 -->
    <PpAddActivity ref="PPHUODONG" @addActivity="init"></PpAddActivity>
    <!-- 品牌建设 -->
    <PpAddTeamBuild ref="PPJIANSHE" @addGain="init"></PpAddTeamBuild>
    <!-- 思政育人 -->
    <PpAddEducatingPeople
      ref="PPSIZHENGYUREN"
      @addEducatingPeople="init"
    ></PpAddEducatingPeople>
    <!-- 品牌成果 -->
    <PpAddAchievement
      ref="PPCHENGGUO"
      @addAchievement="init"
    ></PpAddAchievement>
    <!-- 品牌宣传 -->
    <PpAddPropaganda ref="PPXUANCHUAN" @addPropaganda="init"></PpAddPropaganda>
    <!-- 品牌效果 -->
    <PpAddEffect ref="PPXIAOGUO" @addEffect="init"></PpAddEffect>
    <!-- 思政微课 -->
    <!-- 思政微课基本信息 -->
    <wk-base ref="WKJIBENXINXI" @init="init"></wk-base>
    <!-- 添加老师 -->
    <wk-add-teacher ref="WKTUANDUI" @addTeacher="init"></wk-add-teacher>
    <!-- 微课视频 -->
    <Wksp ref="WKSP" @init="init" />
  </div>
</template>

<script>
// 初始化审核类型列表数据
const initAuditTypeList = () => {
  const result = {};
  Object.keys(AUDIT_TYPE_MAP).forEach((key) => {
    result[key] = AUDIT_TYPE_MAP[key].map((item) => ({
      ...item,
      INSERTNum: 0,
      UPDATENum: 0,
      pendingReviewNum: 0,
      auditPassedNum: 0,
      auditRejectedNum: 0,
      revokedNum: 0,
    }));
  });
  return result;
};
import { getAction, postAction } from "@/api";
import {
  AUDIT_TYPE_MAP,
  FIELD_LABELS,
  AUDIT_STATUS_OPTIONS,
  STATUS_TEXT_MAP,
  STATUS_CLASS_MAP,
  TYPE_MAP,
  FILE_VIEW_MAP,
  CURSOR_POINTER,
} from "@/components/auditPage/data.js";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import Diff from "@/components/common/diff.vue";
import Diff2 from "./difff.vue";
import Reason from "@/components/auditPage/reason.vue";
import RejectReason from "@/components/auditPage/rejectReason.vue";
import TimeLine from "@/components/auditPage/timeLine.vue";
import Evidencelist from "@/components/common/evidencelist";
import newpreview from "@/components/common/newpreviews";
import videopreview from "@/components/common/videopreview";
// 工作室组件
import gzsBase from "@/components/auditPage/gzsBase.vue";
import addTeacher from "@/components/szStudioFileupload/addTeamTeach.vue";
import addTeachRearch from "@/components/szStudioFileupload/addTeachRearch.vue";
import AddActive from "@/components/szStudioFileupload/addActive.vue";
import AddBrand from "@/components/szStudioFileupload/addBrand.vue";
import foundSource from "@/components/szStudioFileupload/addSource.vue";
import foundPay from "@/components/szStudioFileupload/addCapitalExpenditure.vue";
import AddHonor from "@/components/szStudioFileupload/addHonor.vue";
import AddTeamBuild from "@/components/szStudioFileupload/addTeamBuild.vue";
import addScientificeRearch from "@/components/szStudioFileupload/addScientificeRearch.vue";
import AddResult from "@/components/szStudioFileupload/addResult.vue";
import addActivityPlan from "@/components/szStudioFileupload/addActivityPlan.vue";
import AddBase from "@/components/szStudioFileupload/addBase.vue";
import AddBaseActive from "@/components/szStudioFileupload/addBaseActive.vue";
// 编辑品牌组件
import ppAddTeacher from "@/components/educationalBrandFileupload/addTeamTeach.vue";
import ppFoundSource from "@/components/educationalBrandFileupload/addSource.vue";
import ppFoundPay from "@/components/educationalBrandFileupload/addCapitalExpenditure.vue";
import PpAddAnnualPlan from "@/components/educationalBrandFileupload/addAnnualPlan.vue";
import PpAddActivity from "@/components/educationalBrandFileupload/addActive.vue";
import PpAddTeamBuild from "@/components/educationalBrandFileupload/addBrandBuild.vue";
import PpAddEducatingPeople from "@/components/educationalBrandFileupload/addEducatingPeople.vue";
import PpAddAchievement from "@/components/educationalBrandFileupload/addAchievement.vue";
import PpAddPropaganda from "@/components/educationalBrandFileupload/addPropaganda.vue";
import PpAddEffect from "@/components/educationalBrandFileupload/addEffect.vue";
// 思政微课
import wkAddTeacher from "@/components/szMicroClassFileupload/addTeamTeach.vue";
import wkBase from "./wkBase.vue";
import ppBase from "./ppBase.vue";
import Wksp from "./wksp.vue";

export default {
  name: "AuditPage",
  components: {
    Diff,
    Diff2,
    Reason,
    RejectReason,
    TimeLine,
    Evidencelist,
    addTeacher,
    AddActive,
    AddBrand,
    foundSource,
    foundPay,
    AddHonor,
    AddTeamBuild,
    addScientificeRearch,
    AddResult,
    addActivityPlan,
    AddBase,
    AddBaseActive,
    addTeachRearch,
    ppAddTeacher,
    ppFoundSource,
    ppFoundPay,
    PpAddAnnualPlan,
    PpAddActivity,
    PpAddTeamBuild,
    PpAddEducatingPeople,
    PpAddAchievement,
    PpAddPropaganda,
    PpAddEffect,
    wkAddTeacher,
    gzsBase,
    ppBase,
    wkBase,
    Wksp,
    newpreview,
    videopreview,
  },
  data() {
    return {
      cursorPointer: CURSOR_POINTER,
      zh_CN,
      locale,
      fieldLabels: FIELD_LABELS,
      checkedList: [],
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      filters: {
        auditStatus: [],
        dateRange: [],
      },
      auditTotal: 0,
      auditTypeList: initAuditTypeList(),
      auditStatusOptions: AUDIT_STATUS_OPTIONS,
      activeApplication: {},
      detailList: [],
      currentAuditType: 1,
      school: "",
      studio: "",
      statusTextMap: STATUS_TEXT_MAP,
      statusClassMap: STATUS_CLASS_MAP,
      typeMap: TYPE_MAP,
      evidencelistTitle: "",
      sj: {},
      id: "",
      showtable: false,
      // diff 参数
      oldJsonStr: "",
      newJsonStr: "",
      oldData: {},
      newData: {},
      showDiff: false,
      error: "",
      routerNameMap: {
        1: "szStudio",
        2: "educationalBrand",
        3: "szMicroClass",
      },
      showiframe: false,
      previewUrl: "",
      dialogTitle: "",
      showvideo: false,
      sjData: {},
      // 左侧批量审核选中项
      checkedBatchList: [],
      remark: "",
      isInitialized: false, // 添加一个初始化标志
    };
  },
  computed: {
    isEducationRole() {
      return this.$store.state.role === "audit-role";
    },
    title() {
      return this.isEducationRole ? "审核列表" : "更新列表";
    },
    description() {
      return this.isEducationRole ? "暂无审核数据" : "暂无更新数据";
    },
    currentAuditTypeList() {
      return this.auditTypeList[this.currentAuditType] || [];
    },

    // 获取可选的项（auditState == 1）
    selectableItems() {
      return this.detailList.filter((item) => item.auditState == 1);
    },

    // 右侧全选状态
    isAllChecked() {
      if (this.selectableItems.length === 0) return false;
      return this.checkedList.length === this.selectableItems.length;
    },

    // 右侧半选状态
    isIndeterminate() {
      return (
        !!this.checkedList.length &&
        this.checkedList.length < this.selectableItems.length
      );
    },

    currentFieldLabels() {
      return (
        this.fieldLabels[this.currentAuditType][this.activeApplication.id] || {}
      );
    },
    hasDetailData() {
      return this.detailList?.length > 0;
    },
    // 左侧筛选后的审核项列表
    filterAuditItems() {
      return this.currentAuditTypeList.filter(
        (item) =>
          item.pendingReviewNum > 0 ||
          item.auditRejectedNum > 0 ||
          item.auditPassedNum > 0
      );
    },

    // 左侧全选状态
    isBatchAllChecked() {
      if (this.filterAuditItems.length === 0) return false;
      return this.checkedBatchList.length === this.filterAuditItems.length;
    },

    // 左侧半选状态
    isBatchIndeterminate() {
      return (
        this.checkedBatchList.length > 0 &&
        this.checkedBatchList.length < this.filterAuditItems.length
      );
    },
  },
  watch: {
    // 监听 currentAuditType 变化
    currentAuditType: {
      immediate: true,
      handler(newVal) {
        if (this.auditTypeList[newVal] && this.auditTypeList[newVal]?.length) {
          // 只在类型切换时设置第一个，并且只在初始化或当前没有选中项时设置
          if (!this.activeApplication.id || !this.isInitialized) {
            const firstFilteredItem = this.filterAuditItems[0];
            if (firstFilteredItem) {
              this.activeApplication = firstFilteredItem;
              // 这里不调用 getDetail，由 activeApplication 的 watch 处理
            }
          }
        }
      },
    },

    // 监听 activeApplication 变化（主要在这里调用 getDetail）
    activeApplication: {
      handler(newVal, oldVal) {
        // 只有在有 id 且发生变化时才调用
        if (newVal && newVal.id && newVal.id !== oldVal?.id) {
          this.checkedList = []; // 清空右侧选中项
          this.checkedBatchList = []; // 清空左侧选中项
          this.getDetail();
        }
      },
      deep: true,
      immediate: false,
    },

    // filterAuditItems 监听器
    filterAuditItems: {
      handler(newItems) {
        // 只有在 filterAuditItems 有数据且当前没有选中项时才设置第一个
        if (newItems.length > 0 && !this.activeApplication.id) {
          this.activeApplication = newItems[0];
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleItemSelect(item) {
      // 如果当前项已经是激活状态，不重复加载
      if (this.activeApplication.id === item.id) return;

      this.activeApplication = item;
      // checkedList 和 checkedBatchList 的清理由 watch 处理
    },
    handlePreview(data, key) {
      console.log("🚀 ~ handlePreview ~ data, key:", data, key);
      const currentFileList =
        FILE_VIEW_MAP[this.currentAuditType][this.activeApplication.id];
      console.log("🚀 ~ handlePreview ~ currentFileList:", currentFileList);
      const fileViewKeyList = Object.keys(currentFileList);
      console.log("🚀 ~ handlePreview ~ fileViewKeyList:", fileViewKeyList);
      if (fileViewKeyList.includes(key)) {
        const currentUrlName = currentFileList[key].urlName;
        const currentName = currentFileList[key].name;
        console.log("🚀 ~ handlePreview ~ currentName:", currentName);
        console.log("🚀 ~ handlePreview ~ currentUrlName:", currentUrlName);
        console.log(
          "🚀 ~ handlePreview ~ data[currentUrlName]:",
          data[currentUrlName]
        );
        if (data[currentUrlName] != "" && data[currentUrlName] != null) {
          if (data[currentUrlName].includes(".mp4")) {
            this.showvideo = true;
            this.sjData = {
              url: data[currentUrlName],
              title: `${currentName}预览`,
              aliId: data.aliId,
            };
            return;
          }
          this.showiframe = true;
          this.previewUrl = data[currentUrlName];
          this.dialogTitle = `${currentName}预览`;
        }
      }
    },

    changeJson(data) {
      try {
        return JSON.parse(data);
      } catch (e) {
        console.error("JSON解析错误:", e);
        return {};
      }
    },

    // 获取审核数
    async getAuditNum() {
      try {
        const res = await postAction(
          `/audit/lxAuditTask/getModuleChangeCount?currentVersion=0&applyId=${this.$route.query.id}`
        );

        if (res.code === 200) {
          this.auditTotal = res.result.totalNum.totalNum;

          this.currentAuditTypeList.forEach((item) => {
            const moduleData = res.result[item.id] || {};
            item.INSERTNum = moduleData.INSERTNum || 0;
            item.UPDATENum = moduleData.UPDATENum || 0;
            item.pendingReviewNum = moduleData.pendingReviewNum || 0;
            item.auditPassedNum = moduleData.auditPassedNum || 0;
            item.auditRejectedNum = moduleData.auditRejectedNum || 0;
            item.revokedNum = moduleData.revokedNum || 0;
          });

          // 数据加载完成后，如果没有选中项，则设置第一个
          if (!this.activeApplication.id && this.filterAuditItems.length > 0) {
            this.activeApplication = this.filterAuditItems[0];
          }
        }
      } catch (error) {
        console.error("获取审核数量失败:", error);
      }
    },

    // 获取详情数据
    async getDetail() {
      try {
        let params = {
          applyId: this.$route.query.id,
          taskType: this.activeApplication.id,
          auditState: this.filters.auditStatus.join(","),
          startTime: this.filters.dateRange[0]
            ? moment(this.filters.dateRange[0]).format("yyyy-MM-DD")
            : "",
          endTime: this.filters.dateRange[1]
            ? moment(this.filters.dateRange[1]).format("yyyy-MM-DD")
            : "",
          pageNo: this.params.pageNo,
          pageSize: this.params.pageSize,
        };
        const res = await getAction("/audit/lxAuditTask/getAuditList", params);
        if (res.code === 200) {
          this.detailList = res.result.records;
          this.total = res.result.total;
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        this.$message.error("获取详情失败");
      }
    },

    handlePageChange(page, pageSize) {
      this.params.pageNo = page;
      this.params.pageSize = pageSize;
      this.getDetail();
    },

    // 格式化时间
    formatTime(timeStr) {
      return timeStr ? timeStr.replace(" ", "  ") : "";
    },

    // 显示时间线
    getTimeLine(item) {
      this.$refs.timeLine.init(item);
    },
    // 处理全选/取消全选(右侧)
    handleCheckAll(e) {
      console.log("🚀 ~ handleCheckAll ~ e:", e);
      if (e.target.checked) {
        // 全选：只选中所有可选的项目（auditState == 1）
        this.checkedList = this.selectableItems.map((item) => item.id);
      } else {
        // 取消全选
        this.checkedList = [];
      }
    },
    // 左侧全选/取消全选
    handleBatchCheckAll(e) {
      if (e.target.checked) {
        // 全选：只选中所有可见项
        this.checkedBatchList = this.filterAuditItems.map((item) => item.id);
      } else {
        // 取消全选
        this.checkedBatchList = [];
      }
    },

    // 左侧复选框变化
    onBatchChange() {
      // 这里可以添加额外的处理逻辑
    },

    // 批量审核（支持左侧和右侧）
    handleBatchAudit(action, type = "right") {
      const checkedList =
        type === "left" ? this.checkedBatchList : this.checkedList;
      const count = checkedList.length;

      if (count === 0) {
        this.$message.warning("请先选择要审核的项目");
        return;
      }

      const taskIds = checkedList.join(",");
      const title = type === "left" ? "所选模块" : "";

      this.showAuditConfirm(action, count, taskIds, title, type);
    },

    // 统一的审核确认对话框
    showAuditConfirm(action, count, taskIds, title = "", type = "right") {
      const actionText = action === "pass" ? "通过" : "驳回";
      const content = title
        ? `您确定要${actionText}「${title}」吗？`
        : `您确定要${actionText}选中的${count}个项目吗？`;

      this.$confirm({
        title: `确认${actionText}审核`,
        cancelText: "取消",
        okText: "确认",
        content,
        onOk: () => {
          if (action === "reject") {
            this.$refs.rejectReason.init(taskIds, type);
            return;
          }
          this.executeAudit(action, taskIds, type);
        },
      });
    },

    // 执行审核操作
    async executeAudit(action, ids, type = "right") {
      try {
        let endpoint, params;

        if (type === "left") {
          // 左侧批量审核（按模块审核）
          endpoint = "/audit/lxAuditTask/batchAuditTask";
          params = {
            taskTypes: ids,
            auditState: action === "pass" ? 1 : 2, // 1:通过 2:驳回
            remark: "",
            applyId: this.$route.query.id,
          };
        } else {
          // 右侧批量审核（按具体项审核）
          endpoint = "/audit/lxAuditTask/auditTask";
          params = {
            taskIds: ids,
            auditState: action === "pass" ? 1 : 2, // 1:通过 2:驳回
            remark: "",
          };
        }

        const res = await postAction(endpoint, params);
        if (res.code === 200) {
          this.$message.success(
            `已成功${action === "pass" ? "通过" : "驳回"}审核`
          );

          // 清空选中项
          if (type === "left") {
            this.checkedBatchList = [];
          } else {
            this.checkedList = [];
          }

          // 刷新数据
          this.getDetail();
          this.getAuditNum();
        } else {
          this.$message.error(
            res.message || `${action === "pass" ? "通过" : "驳回"}失败`
          );
        }
      } catch (error) {
        console.error("审核操作失败:", error);
        this.$message.error("审核操作失败");
      }
    },

    // 处理单个项目的审核
    handleItemAudit(item, action) {
      this.showAuditConfirm(action, 1, item.id, item.title);
    },
    // 处理编辑操作
    handleEdit(item) {
      console.log(this.activeApplication.id);
      console.log(this.$refs);
      const formatData = this.changeJson(item.dataAfter);
      console.log("🚀 ~ handleEdit ~ formatData:", formatData);
      this.$refs[this.activeApplication.id].init(
        "audit-edit",
        formatData,
        item.id,
        item.detailId
      );
    },

    // 处理撤销操作
    handleCancel(item) {
      this.$confirm({
        title: "确认撤销申请",
        cancelText: "取消",
        okText: "确认",
        content: `您确定要撤销「${this.activeApplication.title}(${
          this.typeMap[item.operation]
        })」吗？`,
        onOk: () => {
          postAction(`/audit/lxAuditTask/cancelTask?ids=${item.id}`).then(
            (res) => {
              if (res.code == 200) {
                this.$message.success("撤销成功");
                this.init();
              }
            }
          );
        },
      });
    },

    // 处理重新提交操作
    handleResubmit(item) {},

    // 显示驳回原因
    handleShowReason(item) {
      this.$refs.reason.init(item.remark);
    },

    // 显示佐证材料
    showeVidence(record) {
      this.evidencelistTitle = this.activeApplication.title;
      this.id = this.$route.query.id;
      this.sj = record;
      this.showtable = true;
    },
    handleRejectSuccess(type) {
      // 清空选中项
      if (type === "left") {
        this.checkedBatchList = [];
      } else {
        this.checkedList = [];
      }
      this.init();
    },
    init() {
      this.getAuditNum();
      this.getDetail();
    },
  },
  mounted() {
    this.currentAuditType = parseInt(this.$route.query.applyType) || 1;
    this.currentAuditName = this.routerNameMap[this.$route.query.applyType];
    this.school = this.$route.query.realname;
    this.studio = this.$route.query.name;

    // 设置初始化标志
    this.isInitialized = true;

    // 只获取审核数量，不主动触发详情获取
    this.getAuditNum();
  },
};
</script>

<style scoped lang="scss">
.audit-page {
  width: 100%;
  height: 100%;
  // max-height: 635px;
  overflow-y: auto;
  padding: 25px 30px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 10px;
  font-family: Microsoft YaHei;
  .btn-action {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 32px;
    padding: 0 15px;
    box-sizing: border-box;
    border-radius: 4px;
    cursor: pointer;

    &.btn-pass {
      background: #43a91b;
      border: 1px solid #43a91b;
    }

    &.btn-reject {
      background: #df0000;
      border: 1px solid #cc0000;
    }
  }
  .empty-state {
    padding: 40px 0;
  }
  .callback-box {
    justify-content: flex-end;
  }
  .label-box {
    height: 60px;
    background: #f3f3f3;
    border-radius: 6px;
    padding: 0 21px;
    box-sizing: border-box;

    .label-text {
      margin-right: 8px;
      font-weight: 500;
    }

    .info-item,
    .filter-item {
      display: inline-flex;
      align-items: center;
      margin-right: 24px;

      &:last-child {
        margin-right: 0;
      }
    }

    .info-value {
      font-weight: 500;
      width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .content-box {
    margin-top: 24px;
    gap: 24px;

    .left {
      width: 315px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #bfd6ff;

      .title {
        border-radius: 6px 6px 0 0;
        padding: 20px;
        box-sizing: border-box;
        background: #2055b5;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #ffffff;

        .audit-total {
          display: inline-block;
          width: 25px;
          height: 25px;
          text-align: center;
          line-height: 25px;
          background: #f5222d;
          border-radius: 13px;
          color: #fff;
        }
      }

      .list-box {
        height: 70vh;
        overflow: auto;
        padding: 16px 10px;

        .item {
          display: flex;
          align-items: flex-start;
          padding: 16px;
          box-sizing: border-box;
          margin-bottom: 16px;
          border-bottom: 1px solid #bfd6ff;
          cursor: pointer;
          transition: all 0.3s;

          &:last-child {
            border: none;
          }

          &.active,
          &:hover {
            background: #2055b5;
            border-color: #2055b5;
            color: #ffffff;

            .num-text,
            .num-box,
            .num-text {
              color: #ffffff !important;
            }
          }

          .item-checkbox {
            flex-shrink: 0;
            margin-top: 3px; // 与标题对齐
          }

          .item-content {
            flex: 1;
            min-width: 0; // 防止内容溢出
          }

          .item-title {
            font-family: MicrosoftYaHei;
            font-size: 16px;
            margin-bottom: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .num-box {
            font-size: 14px;
            color: #5c5c5c;

            span {
              display: inline-block;
              margin-right: 10px;
              margin-bottom: 2px;

              &:last-child {
                margin-right: 0;
              }
            }

            .num-text {
              color: #df5e00;
              font-weight: 500;
              margin: 0 2px;
            }
          }
        }
      }
    }

    .right {
      flex: 1;
      background: #ffffff;

      .ant-checkbox-group {
        width: 100%;
      }
      .right-title {
        padding-bottom: 16px;
        border-bottom: 1px solid #e8e8e8;

        .title-with-bar {
          font-size: 18px;
          font-weight: 500;

          .bar {
            display: inline-block;
            width: 6px;
            height: 20px;
            margin-right: 12px;
            background: #003ba3;
            border-radius: 3px;
          }
        }

        .action-buttons {
          gap: 12px;
        }
      }

      .detail-box {
        margin-top: 24px;
        border-radius: 6px;
        border: 1px solid #bfd6ff;

        .first-title {
          background: #bfd6ff;
          font-weight: bold;
          font-size: 18px;
          color: #2055b5;
          text-align: center;
          padding: 16px;
        }

        .detail-content-box {
          padding: 20px;

          .second-title {
            font-size: 16px;
            color: #6e6e6e;
            border-bottom: 1px solid #e4eeff;
            padding-bottom: 8px;
            margin-bottom: 16px;
          }

          .detail-checkbox {
            margin-bottom: 16px;
          }

          .detail-list-box {
            height: 50vh;
            overflow: auto;

            .detail-item {
              margin-bottom: 24px;

              .detail-title-box {
                font-family: MicrosoftYaHei;
                margin-bottom: 4px;

                .left-content {
                  .detail-text {
                    font-size: 16px;
                    font-weight: 500;
                    .activeApplicationTitle {
                      display: inline-block;
                      width: 120px;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      overflow: hidden;
                    }
                    .INSERT {
                      color: #43a91b;
                    }
                    .UPDATE {
                      color: #df5e00;
                    }
                    .DELETE {
                      color: #df5429;
                    }
                  }
                  .applyNo {
                    margin: 0 6px;
                  }
                  .applyNo,
                  .submit-time {
                    font-size: 14px;
                    color: #787878;
                  }
                }

                .right-content.link-button {
                  color: #2055b5;
                  cursor: pointer;

                  &:hover {
                    text-decoration: underline;
                  }
                }
              }

              .detail-content {
                padding: 16px;
                position: relative;
                background: #f9f9f9;

                .audit-status-box {
                  position: absolute;
                  top: 16px;
                  right: 16px;

                  .evidence-material {
                    font-size: 14px;
                    margin-right: 12px;
                    cursor: pointer;

                    .icon-audit {
                      width: 20px;
                      height: 20px;
                      margin-right: 8px;
                    }
                  }

                  .status-tag {
                    font-family: MicrosoftYaHei;

                    &.audit {
                      color: #d59b00;
                    }

                    &.pass {
                      color: #4faf01;
                    }

                    &.reject {
                      color: #af0101;
                    }
                  }
                }

                .text-cont {
                  color: rgba(0, 0, 0, 0.65);
                  margin-top: 35px;
                  ::v-deep .ant-descriptions-item-label {
                    background-color: #eee;
                  }
                  .text-item {
                    font-family: MicrosoftYaHei;
                    margin-bottom: 8px;

                    .text-title {
                      font-weight: bold;
                      min-width: 80px;
                    }
                  }
                }

                .action-bar {
                  margin-top: 35px;
                  justify-content: flex-end;

                  .reason {
                    position: absolute;
                    bottom: 16px;
                    left: 16px;
                    color: #828282;
                    cursor: pointer;

                    .icon-reason {
                      width: 20px;
                      height: 20px;
                      margin-right: 8px;
                    }
                  }

                  .action-buttons {
                    display: flex;
                    gap: 12px;
                  }

                  .btn-audit {
                    padding: 0 15px;
                    line-height: 32px;
                    border-radius: 4px;
                    cursor: pointer;
                    background: #e4eeff;
                    border: 1px solid #9cb2da;

                    &.btn-commit {
                      background: #bfd6ff;
                      border-radius: 4px;
                      border: 1px solid #1872d8;
                      color: #1872d8;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .preview-pop-box {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    .preview-box {
      margin: 50px auto;
      width: 1177px;
      height: 90%;
    }
    .preview-boxs {
      margin: 50px auto;
      width: 950px;
      height: 700px;
      overflow: hidden;
    }
    .preview-box-fullscreen {
      width: 100vw;
      height: 100vh;
    }
  }
}
</style>